import React, { useMemo } from 'react'
import OneMentorVideoAndOther from './layouts/OneMentorVideoAndOther'

export default function CorrectLayoutHandler({ layout, ...rest }) {
  const ComponentToRender = useMemo(() => {
    // Current OOH modes share the same shell; the layout value is still passed
    // through so the shell can choose single/two/rotating practitioner behavior.
    return OneMentorVideoAndOther
  }, [layout])

  return <ComponentToRender layout={layout} {...rest} />
}
